const DECIMAL_PLACES = 2;

/**
 * Formats a VAT rate as a percentage string with 2 decimal places.
 * Accepts both decimal fractions (0.21) and whole percentages (21).
 */
export function formatVatRate(vatRate: number): string {
  const percentage = vatRate > 1 ? vatRate : vatRate * 100;

  return percentage.toFixed(DECIMAL_PLACES);
}
